import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BrandingMixin',

  computed: {
    getBrandName(): string {
      return this.$store.getters['Config/getBrandName'];
    },

    getBrandLegalName(): string {
      return this.$store.getters['Config/getLegalBusinessName'];
    },

    brandSupportEmail(): string {
      return this.$store.getters['Config/getBrandSupportEmail'];
    },

    brandSupportPhone(): string {
      return this.$store.getters['Config/getBrandSupportPhone'];
    },
  },
});
